import { render, staticRenderFns } from "./MiscPetition.vue?vue&type=template&id=53439004&scoped=true&"
import script from "./MiscPetition.vue?vue&type=script&lang=js&"
export * from "./MiscPetition.vue?vue&type=script&lang=js&"
import style0 from "./MiscPetition.vue?vue&type=style&index=0&id=53439004&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53439004",
  null
  
)

export default component.exports